import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdCustomDomainsAppLinkingAssignments =
  "/companies/:company_id/custom_domains/:domain_type/app_linking_assignments";

export const companiesCompanyIdCustomDomainsAppLinkingAssignment =
  "/companies/:company_id/custom_domains/:domain_type/:domain_parent_id/:domain_id/app_linking_assignment";

// Assigning / unassigning changes a config's embedded assignments, the digest counts, and which
// tracking domains are still assignable — invalidate all three.
const appLinkingAssignmentCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/mobile_app_linking_configs",
  "/companies/:company_id/mobile_app_linking_configs/:id",
  "/companies/:company_id/mobile_app_linking_assignable_tracking_domains",
];

export const putCompaniesCompanyIdCustomDomainsAppLinkingAssignmentsCacheKeys = appLinkingAssignmentCacheKeys;
export const deleteCompaniesCompanyIdCustomDomainsAppLinkingAssignmentCacheKeys = appLinkingAssignmentCacheKeys;
